/*
 * Editor functionality
 */

/**
 * Automatically add editor image caption
 *
 * @param
 *
 * @return void
 */
export let __add_image_caption_editor = async function () {
    return;
    let editor_widgets = $('.stmnt-widget--editor');

    if (editor_widgets.length > 0) {
        for (let editor of editor_widgets) {
            let editor_images = $(editor).find('.stmnt-widget--editor_inner_content_content').find('img');
            if (editor_images.length > 0) {
                for (let image of editor_images) {
                    let image_classlist = Array.from(image.classList);

                    let found_class = false;
                    if (image_classlist.length > 0) {
                        for (let classname of image_classlist) {
                            if (classname.toString().includes('wp-image-')) {
                                found_class = classname;
                            }
                        }
                    }
                    if (found_class != false) {
                        let image_id = found_class.split('-')[2];
                        $.ajax({
                            url: ajaxurl,
                            type: 'POST',
                            dataType: 'json',
                            data: {
                                action: 'stmnt__get_image_data',
                                image_id: image_id,
                            },
                            success: function (data) {
                                let image_author = data.author_source;
                                let image_alt = data.alt;

                                let image_text = image_alt + ' (Quelle: ' + image_author + ')';
                                let image_height = $(image).outerHeight();
                                let image_classes = $(image).attr('class');
                                let image_container = $(
                                    `<div style="height:auto;" class="${image_classes} image-container relative h-auto" data-text="${image_text}"></div>`
                                );
                                let figcaption = $(image).parentsUntil().parent().find('figcaption.wp-caption-text');
                                let current_figcaption_text = $(figcaption).html();
                                current_figcaption_text = current_figcaption_text + ' (Quelle: ' + image_author + ')';
                                $(figcaption).html(current_figcaption_text);
                                /*
                                $(image).css('margin', '0 !important');
                                $(image).wrap(image_container);
                                $(image)
                                    .parent()
                                    .append(`<figcaption class="image-caption">${image_text}</figcaption>`);
                                    */
                            },
                            error: function (error) {
                                // console.log('error', error);
                            },
                        });
                    }
                }
            }
        }
    }
};
